let env = {};

env.baseURL = 'https://api.triagem-hml.ares-saude.com.br/api/v1/';
env.normalURL = 'https://api.triagem-hml.ares-saude.com.br/';
env.wsHost = 'websocket.triagem-hml.ares-saude.com.br';
env.wsPort = '443';
env.wsKey = 'triagem-hml-local-key';

// env.baseURL = 'http://api.triagem.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.triagem.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

// env.baseURL = 'http://api.triagem-sp.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.triagem-sp.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

//env.baseURL = 'https://api.upaicarai.ares-triagem.com.br/api/v1/';
//env.normalURL = 'https://api.upaicarai.ares-triagem.com.br/';
//env.webserviceHost = 'websocket.upaicarai.ares-triagem.com.br';
//env.wsPort = '443';
//env.wsKey = 'triagem-key-key';

//env.baseURL = 'http://localhost:8888/api/v1/';
//env.normalURL = 'http://localhost:8888/';
//env.webserviceHost = 'localhost';
//env.webservicePort = '6001';
//env.wsPort = '443';
//env.wsKey = 'triagem-hml-local-key';
//env.wsHost = 'localhost';
//env.wsPort = '8080';
//env.wsKey = 'triagem-local-key';

export default env
